import {
  convertFolder,
  EditFileParams,
  EditFolderParams,
  RepositoryResponse,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useEditFile() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: editFile,
    onSuccess: async () => {
      const repositoryKey = keys.all
      await client.invalidateQueries({ queryKey: repositoryKey })
    },
  })

  async function editFile({
    name,
    description,
    file,
    externalUrl,
    id,
  }: EditFileParams) {
    const response = await server.put<RepositoryResponse.Folder>(
      `/v2/chat/repository/files/${id}`,
      getFormData(),
      'user',
      'multipart/form-data'
    )
    return convertFolder(response)

    function getFormData() {
      const form = new FormData()
      if (name) {
        form.append('name', name)
      }
      if (description) {
        form.append('description', description)
      }
      if (file) {
        form.append('file', {
          name: file.name ?? '',
          type: file.mimeType,
          uri: file.uri,
        })
      }
      if (externalUrl) {
        form.append('external_url', externalUrl)
      }
      return form
    }
  }
}

export function useEditFolder() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: editFolder,
    onSuccess: async () => {
      const repositoryKey = keys.all
      await client.invalidateQueries({ queryKey: repositoryKey })
    },
  })

  async function editFolder({ name, description, id }: EditFolderParams) {
    const response = await server.put<RepositoryResponse.Folder>(
      `/v2/chat/repository/folders/${id}`,
      getFormData(),
      'user',
      'multipart/form-data'
    )
    return convertFolder(response)

    function getFormData() {
      const form = new FormData()
      if (name) {
        form.append('name', name)
      }
      if (description) {
        form.append('description', description)
      }
      return form
    }
  }
}
